import { create } from "zustand";
import { supabase } from "./supabase";
import Swal from "sweetalert2";

const useProfileStore = create((set, get) => ({
  profile: [],
  loading: false,
  name: "",
  position: "",
  editingRow: null,
  rowData: {},

  // Get profile
  getProfile: async () => {
    const user = JSON.parse(localStorage.getItem("employee"));

    set({ profile: user });
  },

  uploadProfilePicture: async (file, userId) => {
    set({ loading: true });
    try {
      const fileExt = file.name.split(".").pop();
      const fileName = `${userId}-${Date.now()}.${fileExt}`;
      const filePath = `avatars/${fileName}`;

      // 1️⃣ Upload to Supabase Storage
      const { error: uploadError } = await supabase.storage
        .from("profile_images")
        .upload(filePath, file, { upsert: true });

      if (uploadError) throw uploadError;

      // 2️⃣ Get public URL
      const { data } = supabase.storage
        .from("profile_images")
        .getPublicUrl(filePath);
      const publicUrl = data.publicUrl;


      // 3️⃣ Update user record in DB

      const { data: updatedData, error } = await supabase
        .from("employees")
        .update({ image: publicUrl })
        .eq("id", userId)
        .select();

      if (error) throw error;

      set({ profile: { image: updatedData[0].image   }, loading: false });

        Swal.fire("Success", "Profile picture uploaded successfully!", "success");
        
        // Fetch employee
        const { data: employee } = await supabase
          .from("employees")
          .select()
          .eq("id", userId);

        set({ profile: employee[0] });
        
        localStorage.setItem("employee", JSON.stringify(employee[0]));

    } catch (err) {
      console.error("Upload error:", err);
      Swal.fire("Error", err.message, "error");
      set({ loading: false });
    }
  },
}));

export default useProfileStore;
